export class Constants {
  // API URLs
  public static GET_SERVICE_CENTERS_STATUS = '/gis/operationlevel/OperationLevelMapV2-Application/OperationLevelMap-ApplicationUseCaseWebServices/rest/operationlevel';
  public static GET_WEATHER_FORECAST_STATUS = '/gis/operationlevel/OperationLevelMapV2-Application/OperationLevelMap-ApplicationUseCaseWebServices/rest/weatherforecast';

  // ARCGIS
  public static WEATHER_LAYER_URL = 'https://mapservices.weather.noaa.gov/eventdriven/rest/services/WWA/watch_warn_adv/MapServer';
  public static WEATHER_WARNING_LAYER_URL = 'https://mapservices.weather.noaa.gov/eventdriven/rest/services/WWA/watch_warn_adv/MapServer/1';
  
  // Layer ID
  public static ROUTING_SOLVER_LAYER_ID = 'ROUTING_SOLVER_LAYER_ID'
  public static WEATHER_LAYER_ID = 'WEATHER_LAYER_ID'
  public static SERVICE_CENTERS_STATUS_OK_LAYER_ID = 'SERVICE_CENTERS_STATUS_OK_LAYER_ID'
  public static SERVICE_CENTERS_STATUS_WARNINGS_LAYER_ID = 'SERVICE_CENTERS_STATUS_WARNINGS_LAYER_ID'
  
  // Other
  public static GREEN = 'GREEN';
  
}
